import React, { useMemo } from "react"

import { useAppSelector } from "one-verify/src/store/selectors/app.selector"
import { useParams } from "react-router-dom"

import {
    COMMON_ONE_VERIFY_POLICIES_CONFIG,
    PoliciesListType,
} from "@common-shared/config/oneVerify/oneVerifyPolicies.config.ts"
import { OneVerifyPermission } from "@common-shared/config/rolesPermissions.config.ts"

import { SpinnerElement } from "@front-shared/elements/spinner.element.tsx"
import { useScrollFix } from "@front-shared/hooks/scrollFix.hook.ts"

import { useHasPermissions } from "../../../hooks/hasPermissions.hook"
import { selectedPracticeConfigurationSelector } from "../../../store/selectors/selectedPracticeConfiguration.selector"
import { NotFoundComponent } from "../../general/notFound.component"
import { SinglePolicyViewComponent } from "./singlePolicyView.component"

export const SinglePolicyAssignedTasksComponent: React.FunctionComponent =
    () => {
        useScrollFix()

        useHasPermissions([OneVerifyPermission.workTaskAssignments])

        const { nirvanaRequestId } = useParams()

        const selectedPracticeConfiguration = useAppSelector(
            selectedPracticeConfigurationSelector,
        )

        const listType = useMemo<PoliciesListType | null>(() => {
            if (!selectedPracticeConfiguration) {
                return null
            }

            return COMMON_ONE_VERIFY_POLICIES_CONFIG
                .assignedTasksListTypeVariant[
                selectedPracticeConfiguration.workflowManagementVersion
            ]
        }, [selectedPracticeConfiguration?.workflowManagementVersion])

        if (!listType) {
            return <SpinnerElement containerClassName="mt-[32px] text-center" />
        }

        return nirvanaRequestId ? (
            <div className="relative">
                <SinglePolicyViewComponent
                    nirvanaRequestId={nirvanaRequestId}
                    listType={listType}
                />
            </div>
        ) : (
            <NotFoundComponent />
        )
    }
